import { Fragment } from "react";
import { Box } from "@mui/material";
import { Skeleton } from "@mui/lab";

import { Breadcrumbs, PageHeader, Spinner } from "@dzambalaorg/mui-page-layout";
import { RichTextDisplay } from "@dzambalaorg/mui-rte";
import { StyledAvatar } from "@framework/styled";
import type { IContract } from "@framework/types";
import { useFetchData } from "@dzambalaorg/react-hooks";
import { Avatar, Typography } from "@dzambalaorg/ui-kit";

import { LotteryPurchase } from "./purchase";
import { LotteryStatistic } from "./statistics";

export const LotteryContract = () => {
  const { data, isLoading } = useFetchData<IContract>("/lottery/contracts");

  if (isLoading) {
    return <Spinner />;
  }

  if (!data) {
    // TODO - [AFTER ALL REFACTORING] - add universal no data component
    return <div>No data</div>;
  }

  return (
    <Fragment>
      <Breadcrumbs path={["dashboard", "lottery", "lottery.contract"]} data={[{}, {}, data]} />

      <PageHeader message="pages.lottery.contract.title" data={data} />

      <Box display="flex">
        <Box margin={1}>
          {isLoading ? (
            <Skeleton variant="circular">
              <Avatar />
            </Skeleton>
          ) : (
            <StyledAvatar src={data.imageUrl} />
          )}
        </Box>
        <Box width="100%">
          {isLoading ? (
            <Skeleton width="100%">
              <Typography>.</Typography>
            </Skeleton>
          ) : (
            <Typography variant="body2" color="textSecondary" component="div">
              <RichTextDisplay data={data.description} />
            </Typography>
          )}
        </Box>
      </Box>

      <LotteryPurchase contract={data} />
      <LotteryStatistic contract={data} />
    </Fragment>
  );
};
